
var List = function() {
    this._content = [];
};

List.prototype.add = function(idx, val){
    if (Math.abs(idx) <= this._content.length) this._content.splice(idx, 0, val);
};

List.prototype.push = function(val){
    return this.add(this._content.length, val);
};

List.prototype.put = function(idx, val){ // TODO: put at the end of a list should equal add!
    if (idx < 0) idx = this._content.length + idx;
    if (idx >= 0 && idx <= this._content.length) this._content[idx] = val;
};

List.prototype.addAll = function(list){ // adds given list in original positions => given list will be added in front of original one
    var self = this;
    if(list instanceof Array) {
        list.forEach(function(element, idx) {
            self.add(idx, element);
        });
    } else if (list instanceof List){
        list.forEach(function(idx, element) {
            self.add(idx, element);
        });
    }
};

List.prototype.get = function(idx){
    return this._content[idx >= 0 ? idx : this._content.length + idx];
};

List.prototype.getOne = function(){
    return this._content[0];
};

List.prototype.last = function(){
    return this._content[this._content.length-1];
};

List.prototype.size = function(){
    return this._content.length;
};

List.prototype.isEmpty = function(){
    return this._content.length === 0;
};

List.prototype.indexOf = function(val){
    return this._content.indexOf(val);
};

List.prototype.hasIndex = function(idx){
    return (idx >= 0) && (idx < this._content.length);
};

List.prototype.contains = function(val){
    return this.indexOf(val) !== -1;
};

List.prototype.forEach = function(f){
    var initialLength = this._content.length;
    for (var idx=0; idx<this._content.length; idx++) {
        f(idx, this._content[idx]);
        console.assert(this._content.length == initialLength, "Don't change the content of a collection while iterating (forEach)");
    }
};

List.prototype.forEachPair = function(f, includeEquals){
    for (var i0 = 0; i0 < this._content.length; i0++){
        if (includeEquals){
            for (var i1 = 0; i1 <= i0; i1++){
                f(i0, this._content[i0], i1, this._content[i1]);
            }
        } else {
            for (var i1 = 0; i1 < i0; i1++){
                f(i0, this._content[i0], i1, this._content[i1]);
            }
        }
    }
};

List.prototype.remove = function(idx) {
    if (Math.abs(idx) <= this._content.length) return this._content.splice(idx, 1)[0];
};

List.prototype.pop = function(){
    return this.remove(-1);
};

List.prototype.removeAll = function(){
    while (this._content.length > 0) this.remove(-1);
};

List.prototype.removeWhere = function(f){
    for (var idx = this._content.length-1; idx>=0; idx--){
        if (f(idx, this._content[idx])) this.remove(idx);
    }
};

List.prototype.removeValue = function(val){
    this.removeWhere(function(i, v){
        return v == val;
    });
};

List.prototype.move = function(from, to){
    if (from < 0) from = this._content.length + from;
    if (to < 0) to = this._content.length + to;
    if (this.hasIndex(from) && this.hasIndex(to) && from != to) {
        this.add(to, this.remove(from));
    }
};

List.prototype.moveValue = function(val, offset){
    var from = this.indexOf(val);
    if (from == -1) return;
    var to = from + offset;
    if (to < 0) to = 0;
    if (to > this._content.length) to = this._content.length-1;
    this.move(from, to);
};

List.prototype.swap = function(idx1, idx2){
    if (idx1 < 0) idx1 = this._content.length + idx1;
    if (idx2 < 0) idx2 = this._content.length + idx2;
    if (this.hasIndex(idx1) && this.hasIndex(idx2) && idx1 != idx2) {
        var val = this.get(idx1);
        this.put(idx1, this.get(idx2));
        this.put(idx2, val);
    }
};

List.prototype.swapValue = function(val1, val2){
    var idx1 = this.indexOf(val1);
    var idx2 = this.indexOf(val2);
    if (idx1 == -1 || idx2 == -1) return;
    this.swap(idx1, idx2);
};

List.prototype.copy = function() {
    var result = new List();
    result.addAll(this);
    return result;
};

List.prototype.filter = function(f){
    var result = new List();
    this.forEach(function(idx, val){
        if (f(idx, val)) result.push(val);
    });
    return result;
};

List.prototype.map = function(f){
    var result = new List();
    this.forEach(function(idx, val){
        result.add(idx, f(idx, val));
    });
    return result;
};

List.prototype.sort = function(compare){
    this._content.sort(compare);
};

List.prototype.reduce = function(f, initialValue){
    var result = initialValue != undefined ? initialValue : 0;
    this.forEach(function(idx, val){
        result = f(result, idx, val);
    });
    return result;
};

List.prototype.getMin = function(compare){ // compare function should return negative number when a < b, return 0 when a = b, return positive number when a > b
    if (!compare) compare = function(a,b){return a<b? -1: a>b? 1:0;};
    var min = this._content[0];
    for (var i = 1; i<this._content.length; i++) {
        if (compare(this._content[i], min) < 0) min = this._content[i];
    }
    return min;
};

List.prototype.getMax = function(compare){
    if (!compare) compare = function(a,b){return a<b? -1: a>b? 1:0;};
    var max = this._content[0];
    for (var i = 1; i<this._content.length; i++) {
        if (compare(this._content[i], max) > 0) max = this._content[i];
    }
    return max;
};

List.prototype.find = function(f){
    for (var i=0; i<this._content.length; i++) {
        if (f(i, this._content[i])) return this._content[i];
    }
};

List.prototype.some = function(f){
    for (var i=0; i<this._content.length; i++) {
        if (f(i, this._content[i])) return true;
    }
    return false;
};

List.prototype.every = function(f){
    for (var i=0; i<this._content.length; i++) {
        if (!f(i, this._content[i])) return false;
    }
    return true;
};

List.prototype.equals = function(list, compare) {
    if(!compare) compare = function(a,b) { return a == b; };
    if (Array.isArray(list)){
        if(this.size() !== list.length) return false;
        return this.every(function(idx, val){
            return compare(val, list[idx]);
        });
    } else {
        if(this.size() !== list.size()) return false;
        return this.every(function(idx, val){
            return list.hasIndex(idx) && compare(val, list.get(idx));
        });
    }
};

List.prototype.toArray = function(){
    return this._content.slice();
};

module.exports = List;